import { createSlice } from '@reduxjs/toolkit';

import { IExecutedJob, IScheduledJob } from '../../api/mock';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IJobListState {
	scheduledJobs: IScheduledJob[];
	executedJobs: IExecutedJob[];
}

const initialState: IJobListState = {
	scheduledJobs: [],
	executedJobs: [],
};

export const jobListSlice = createSlice({
	name: 'scheduledList',
	initialState,
	reducers: {
		setScheduledList: (state, action: PayloadAction<IScheduledJob[]>) => {
			state.scheduledJobs = action.payload;
		},
		setExecutedList: (state, action: PayloadAction<IExecutedJob[]>) => {
			state.executedJobs = action.payload;
		},
	},
});

export const { setScheduledList, setExecutedList } = jobListSlice.actions;
export default jobListSlice.reducer;
